import { IndexTable, LegacyCard } from "@shopify/polaris";
import React from "react";

const rowPart = (value) => String(value ?? "").trim();

export const gdprRowId = (record = {}, index = 0) => {
  const identity = [
    record.id,
    record.dataRequestId,
    record.gdprActionType,
    record.shopDomain,
    record.customerId,
    record.requestedAt,
    index,
  ]
    .map(rowPart)
    .join("::");
  return `gdpr-row::${identity}`;
};

function GdprTable({ gdprContant = [] }) {
  const resourceName = {
    singular: "data",
    plural: "data",
  };

  const rowMarkup = gdprContant.map((record, index) => {
    const {
      shopDomain,
      customerId,
      customerEmail,
      customerPhone,
      dataRequestId,
      body,
      gdprActionType,
      requestedAt,
      processedAt,
    } = record;
    const rowId = gdprRowId(record, index);
    return (
      <IndexTable.Row id={rowId} key={rowId} position={index}>
        <IndexTable.Cell>{shopDomain}</IndexTable.Cell>
        <IndexTable.Cell>{customerId}</IndexTable.Cell>
        <IndexTable.Cell>{customerEmail}</IndexTable.Cell>
        <IndexTable.Cell>{customerPhone}</IndexTable.Cell>
        <IndexTable.Cell>{dataRequestId}</IndexTable.Cell>
        <IndexTable.Cell>{body}</IndexTable.Cell>
        <IndexTable.Cell>{gdprActionType}</IndexTable.Cell>
        <IndexTable.Cell>{requestedAt}</IndexTable.Cell>
        <IndexTable.Cell>{processedAt}</IndexTable.Cell>
      </IndexTable.Row>
    );
  });

  return (
    <LegacyCard>
      <IndexTable
        resourceName={resourceName}
        itemCount={gdprContant.length}
        headings={[
          { id: "1", title: "Shop domain" },
          { id: "2", title: "Customer Id" },
          { id: "3", title: "Customer email" },
          { id: "4", title: "Customer phone" },
          { id: "5", title: "Data Request Id" },
          { id: "6", title: "Body" },
          { id: "7", title: "GDPR action type" },
          { id: "8", title: "Requested At" },
          { id: "9", title: "Processed At" },
        ]}
        selectable={false}
      >
        {rowMarkup}
      </IndexTable>
    </LegacyCard>
  );
}

export default GdprTable;
